import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=794ae1ec"
import script from "./Visitors.vue?vue&type=script&lang=ts"
export * from "./Visitors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports